module.exports = __webpack_public_path__ + "assets/img/img_ewm.a647e04d.png";